(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.track = this.querySelector('.announcement-bar__slider-track');
      if (!this.track) return;

      this.slides = Array.from(this.track.children);
      if (this.slides.length <= 1) return;

      // Clone the first slide and append it, so the track can slide one
      // step past the real last slide and then jump back invisibly for
      // a seamless infinite loop.
      this.loopClone = this.slides[0].cloneNode(true);
      this.loopClone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(this.loopClone);

      this.currentIndex = 0;
      this.isAnimating = false;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.handleTransitionEnd = (event) => this._onTransitionEnd(event);
      this.track.addEventListener('transitionend', this.handleTransitionEnd);

      // A backgrounded tab throttles/suspends setInterval and can stop
      // transitionend from firing at all, so currentIndex can drift past
      // the loop clone with nothing left to settle it back. Restoring on
      // every visibility/lifecycle signal guarantees a valid slide is
      // always shown again, instead of relying on transitionend alone.
      this.handleVisibilityChange = () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this._restoreAndResume();
        }
      };
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      this.handleRestore = () => this._restoreAndResume();
      this.handlePageHide = () => this.stopAutoplay();
      window.addEventListener('pageshow', this.handleRestore);
      window.addEventListener('focus', this.handleRestore);
      window.addEventListener('pagehide', this.handlePageHide);

      if (this.autoplayEnabled) {
        this.handleMouseEnter = () => this.stopAutoplay();
        this.handleMouseLeave = () => this._restoreAndResume();
        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
      }

      this._restoreAndResume();
    }

    disconnectedCallback() {
      if (this.track && this.handleTransitionEnd) {
        this.track.removeEventListener('transitionend', this.handleTransitionEnd);
      }
      if (this.handleVisibilityChange) {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }
      if (this.handleRestore) {
        window.removeEventListener('pageshow', this.handleRestore);
        window.removeEventListener('focus', this.handleRestore);
      }
      if (this.handlePageHide) {
        window.removeEventListener('pagehide', this.handlePageHide);
      }
      if (this.handleMouseEnter) this.removeEventListener('mouseenter', this.handleMouseEnter);
      if (this.handleMouseLeave) this.removeEventListener('mouseleave', this.handleMouseLeave);
      this.stopAutoplay();
    }

    // Snaps the track back to a guaranteed-valid resting position on the
    // current slide (normalizing the index first, in case it drifted
    // past the loop clone while hidden) and clears any stale in-flight
    // flag. transition is disabled for the jump so the recovery is never
    // visible, then restored so the next automatic swipe animates as usual.
    _normalizeToCurrentSlide() {
      const count = this.slides.length;
      this.currentIndex = ((this.currentIndex % count) + count) % count;
      this.isAnimating = false;
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      this.track.offsetHeight; // reflow, so the transition re-enables cleanly
      this.track.style.transition = '';
    }

    _restoreAndResume() {
      this._normalizeToCurrentSlide();
      this.startAutoplay();
    }

    _onTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform') return;
      this.isAnimating = false;
      if (this.currentIndex === this.slides.length) {
        this._normalizeToCurrentSlide();
      }
    }

    showNext() {
      if (this.isAnimating || document.hidden) return;
      this.isAnimating = true;
      this.currentIndex += 1;
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplayEnabled || document.hidden) return;
      const interval = Number(this.dataset.interval) || 4000;
      // Self-scheduling timeout: the next tick is only queued after this
      // one runs, so a throttled/delayed background tab can never stack
      // up multiple pending advances the way a bare setInterval could.
      this.autoplayTimer = window.setTimeout(() => {
        this.showNext();
        this.startAutoplay();
      }, interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        const summary = item.querySelector('summary');
        summary.addEventListener('click', (event) => this._handleClick(event, item));
      });
    }

    _handleClick(event, item) {
      event.preventDefault();
      if (item.dataset.animating) return;
      this._toggle(item, !item.classList.contains('is-open'));
    }

    _toggle(item, opening) {
      if (item.dataset.animating || opening === item.classList.contains('is-open')) return;
      const body = item.querySelector('.faq-item__body');
      item.dataset.animating = 'true';

      if (opening) {
        item.setAttribute('open', '');
        body.style.height = '0px';
        body.offsetHeight; // reflow, so the transition starts from 0
        item.classList.add('is-open');
        body.style.height = body.scrollHeight + 'px';
      } else {
        body.style.height = body.scrollHeight + 'px';
        body.offsetHeight; // reflow, so the transition starts from the current height
        item.classList.remove('is-open');
        body.style.height = '0px';
      }

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;
        body.removeEventListener('transitionend', onTransitionEnd);
        if (opening) {
          body.style.height = 'auto';
        } else {
          item.removeAttribute('open');
        }
        delete item.dataset.animating;
      };
      body.addEventListener('transitionend', onTransitionEnd);
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();
})();
